import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import HomeVideo from "../components/HomeVideo.vue";
import ARvideo from "../components/ARVideo.vue";
import HomeRec from "../components/HomeRec.vue";
import HomeTuijian from "../components/HomeTuijian.vue";
import ShopIndex from "../components/ShopIndex.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    children: [
      {
        path: "/",
        components: {
          location1: HomeVideo,
          location2: HomeRec,
          location3: ShopIndex
        }
      },
      {
        path: "HomeVideo",
        components: {
          location1: HomeVideo,
          location2: HomeRec,
          location3: ShopIndex
        }
      },
      {
        path: "ARvideo",
        components: {
          location1: ARvideo,
          location2: HomeRec,
          location3: ShopIndex
        }
      },
      {
        path: "/",
        components: {
          location1: HomeVideo,
          location2: HomeRec,
          location3: ShopIndex
        }
      },
      {
        path: "HomeRec",
        components: {
          location1: HomeVideo,
          location2: HomeRec,
          location3: ShopIndex
        }
      },
      {
        path: "HomeTuijian",
        components: {
          location1: HomeVideo,
          location2: HomeTuijian,
          location3: ShopIndex
        }
      },
      {
        path: "/",
        components: {
          location1: HomeVideo,
          location2: HomeTuijian,
          location3: ShopIndex
        }
      },
      {
        path: "ShopIndex",
        components: {
          location1: HomeVideo,
          location2: HomeTuijian,
          location3: ShopIndex
        }
      }
    ]
  },
  {
    // 资讯
    path: "/Information",
    name: "Information",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Information.vue")
  },
  {
    // 播报
    path: "/Broadcast",
    name: "Broadcast",
    component: () => import("../views/Broadcast.vue")
  },
  {
    // 播报
    path: "/BroDetail",
    name: "BroDetail",
    component: () => import("../views/BroDetail.vue")
  },
  {
    // 视频
    path: "/Video",
    name: "Video",
    component: () => import("../views/Video.vue")
  },
  {
    // 推荐
    path: "/Recommend",
    name: "Recommend",
    component: () => import("../views/Recommend.vue")
  },
  {
    // 美图
    path: "/Mito",
    name: "Mito",
    component: () => import("../views/Mito.vue")
  },
  {
    // 视频播放
    path: "/VideoDetail",
    name: "VideoDetail",
    component: () => import("../views/VideoDetail.vue")
  },
  {
    // 资讯详情
    path: "/InfDetail",
    name: "InfDetail",
    component: () => import("../views/InfDetail.vue")
  },
  {
    // 美图详情
    path: "/MitoDetail",
    name: "MitoDetail",
    component: () => import("../views/MitoDetail.vue")
  }
];

const router = new VueRouter({
  // mode: "history",
  routes
});

export default router;
